import { dollars } from './buildings';
import { Rng } from './rng';

/*
 * Air shows: now and then an aerobatic team flies a display over the airport, once it has a
 * proper tower (level 3) and somewhere for the crowd to watch from (a spotters' deck). The
 * morning brings the news, the afternoon the show: the decks fill up (each pays by its level)
 * and everyone talks about it. Whether a day has a show follows from the world's seed and the
 * day alone, so nothing needs saving and the rest of the world's luck is untouched.
 */

/** Chance (percent) of a show on a given day, and when it is announced and flown. */
export const AIRSHOW_PERCENT = 12;
export const AIRSHOW_ANNOUNCE_MINUTE = 7 * 60;
export const AIRSHOW_MINUTE = 15 * 60;
/** The tower level a display team asks for. */
export const AIRSHOW_TOWER_LEVEL = 3;
/** What each deck takes per level for the show, and the buzz it makes. */
export const AIRSHOW_DECK_INCOME = dollars(6_000);
export const AIRSHOW_BUZZ = 250;

/** Whether day `day` (from 0) of the world with `seed` has an air show. */
export function airshowDay(seed: number, day: number): boolean {
  const draw = new Rng((seed ^ Math.imul(day + 1, 0x27d4eb2d)) >>> 0);
  return draw.int(100) < AIRSHOW_PERCENT;
}
